import type { QaStatusArtifact } from './types'
import { createQaMeter as createQaMeterImpl } from './mount'

export interface QaMeterOptions {
  /** Where the QA status artifact comes from. An inline object renders
   *  immediately; a URL is `fetch`ed lazily on first open/hover; a function is
   *  invoked lazily likewise. */
  source: string | QaStatusArtifact | (() => Promise<QaStatusArtifact>)
  /** Router-aware override. Defaults to a routerless resolver over the
   *  artifact's path_patterns + `window.location.pathname`. */
  getCurrentPage?: () => string | null
  locale?: 'fr' | 'en'
  /** Pastille size. 'md' (48px, default) for standalone; the feedback-widget
   *  integration passes 'sm' (24px) so the QA FAB reads as secondary. */
  size?: 'sm' | 'md'
  position?: { right?: number; bottom?: number }
}

export interface QaMeterHandle {
  open(): void
  close(): void
  dispose(): void
}

export function createQaMeter(options: QaMeterOptions): QaMeterHandle {
  return createQaMeterImpl(options)
}

export type {
  QaStatusArtifact,
  QaColor,
  QaScenario,
  QaPageStatus,
  QaSitemapNode,
} from './types'
